import { observable } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';
import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { go } from '@src/utils/promise';
import AntdMessage from '@src/components/antd/message';
import $$tracker from '@src/tracker';

class QrcodeModalStore extends BaseModalStore {
  @observable qrcodeImg = '';
  @observable loading = false;
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  /** 关闭弹窗 */
  onQrcodeModalClose = () => {
    this.onClickClose();
    if (this.closeCb) this.closeCb();
    this.onClose();
  };

  /** 切换到表单弹窗 */
  changeToFormModal = () => {
    this.onQrcodeModalClose();
    this.goToFormModal();
    $$tracker.clickPopupPhoneReserve('二维码弹窗');
  };

  getQrcode = async () => {
    this.loading = true;
    const [res, err] = await go(this.$ztService.getQrCode());
    this.loading = false;
    if (err) {
      AntdMessage.error(err.message);
      return;
    }
    this.qrcodeImg = res?.img || '';
  };

  use(onClose) {
    super.use();
    if (onClose) {
      this.onClose = onClose;
    }
    useMount(() => this.getQrcode());
  }
}

export default QrcodeModalStore;
